module.exports = __webpack_public_path__ + "img/img_webinar2.8e2876a4.jpg";